import { render, staticRenderFns } from "./LibrariesList.vue?vue&type=template&id=28a3f78b&scoped=true&"
import script from "./LibrariesList.vue?vue&type=script&lang=js&"
export * from "./LibrariesList.vue?vue&type=script&lang=js&"
import style0 from "./LibrariesList.vue?vue&type=style&index=0&id=28a3f78b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a3f78b",
  null
  
)

export default component.exports